
<script>

import { defineComponent } from 'vue'
import CheckboxToggle from '@/ui/CheckboxToggle'

//data
import { getGalleryOptions } from '@/services/serviceGallery';
import { getPhotosPreviewByGallery } from '@/services/servicePhoto';

export default defineComponent({
  name: 'ComponentGallery',
	data() {
		return {
			optionsGalleries: [],
			photos: [],
			galleryId: '',
			paddingBottom: 0,
			showName: false,
			workContent:{}
		}
	},
  props: {
	'content': Object
  },
  emits: ["content","changeContent"],
  components: {
    CheckboxToggle
  }
	,mounted () {
		this.loadOptions();
		this.galleryId=this.content.fields.galleryId;
		if(this.content.fields.showName){
			this.showName=this.content.fields.showName;
		}
		if(this.content.fields.paddingBottom){
			this.paddingBottom=this.content.fields.paddingBottom;
		}
		this.workContent = this.content;
		this.loadPreview();
	},
  
	methods: {
		// load data form
		loadOptions:function(){
			
			getGalleryOptions().then(response => {
				if(!response.statusText){
					this.optionsGalleries = response.optionsGalleries;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			
		},

		loadPreview:function(){
			
			if(this.workContent.fields.galleryId){
				this.preloader=true;
				getPhotosPreviewByGallery({galleryId:this.workContent.fields.galleryId}).then(response => {
					if(!response.statusText){
						this.preloader=false
						this.photos = response.photos;
					}else{
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});

			}else{
				this.photos=[];
			}
		
		},
		
		sendContent:function(){
			this.workContent.content = JSON.stringify(this.workContent.fields);
			this.$emit('changeContent', this.workContent)
		},

		onChangeGalleryId:function(){
			this.workContent.fields.galleryId=this.galleryId;
			this.sendContent();
		},

		onChangeShowName:function(e){
			this.workContent.fields.showName=e;
			this.sendContent();
		},

		onChangePaddingBottom:function(){
			console.log(this.paddingBottom)
			this.workContent.fields.paddingBottom=this.paddingBottom;
			this.sendContent();
		}

	},
	
	watch: {
	
	},
	
	created() {

	}
})
</script>

<template>
	<div>
		<div class="col-md-4 col-12">
			<label><b>{{ $t('msgCore.Gallery') }}</b></label>
			<select v-model='galleryId' class="form-control form-control-sm" v-on:change="onChangeGalleryId();loadPreview();" >
				<option  value="">{{ $t('msgCore.selectGallery') }}</option>
				<option v-for="(option) in optionsGalleries" :value="option.value" :key="option">{{ option.title }}</option>
			</select>
		</div>

		<div class="col-12 col-md-4">
			<label><b>{{ $t('msgCore.showName') }}</b></label>
			<CheckboxToggle :key="`gal${galleryId}`" :data="showName" @onClick="onChangeShowName"></CheckboxToggle>
		</div>

		<div class="col-12 col-md-4">
			<label><b>{{ $t('msgCore.paddingBottom') }}</b></label><br>
			
			<div v-for="(option) in 5" :key="option" class="form-check-inline">
				<label class="form-check-label">
					<input class="form-check-input" type="radio" :name="`paddingBottom${galleryId}`" v-model='paddingBottom' v-on:change="onChangePaddingBottom()" :value="option">
					{{ option }}
					<span class="circle">
						<span class="check"></span>
					</span>
				</label>
			</div>
			
		</div>

		<div class="col-12">
			<div v-for="photo in photos" class="crop_gallery2" :key="photo">
				<img :src="photo.photoData" :title="photo.title">
			</div>
		</div>

	</div>
</template>